import React from 'react';
import PropTypes from 'prop-types';
import HeadingComponent from './HeadingComponent/HeadingComponent';
import DescriptionComponent from './DescriptionComponent';


const HeadingGroup = (props) => {
  return (
    <div className="heading-group-wrapper">
       <HeadingComponent plainText={props.headingPlainText} strongText={props.headingStrongText}/>
       <DescriptionComponent>{props.description}</DescriptionComponent>
    </div>
  );
};

HeadingGroup.propTypes = {
    headingPlainText: PropTypes.string,
    headingStrongText: PropTypes.string,
    description: PropTypes.string,
}

export default HeadingGroup;